<template>
    <div>
        <p class="first_content">
            <span class="requirements" :class="{'ishide': !ismock}"><span class="require_title">作业要求：</span>{{description}}</span>
            <span class="comment">
                <span class="requirement_detail" v-if="ismock" @click='look_detail'>详情</span>
                <!-- <el-button plain size="middle" @click='default_comment'>默认语点评</el-button> -->
                <el-button plain size="middle" @click='ueditor_flag = true' v-if='getOverall'>整体点评</el-button>
            </span>
        </p>
        <div class="content_box">
            <div class="content_left">
                <p class="content_tab">
                    <span @click='tabchange(0)' :class='{a:cur==0}' @contextmenu.prevent ='right_click'>材料</span>
                    <span @click='tabchange(1)' :class='{a:cur==1}' @contextmenu.prevent ='right_click' v-if='thought_flag'>思路点拨</span>
                    <span @click='tabchange(2)' :class='{a:cur==2}' @contextmenu.prevent ='right_click' v-if='explain_flag'>解析</span>
                    <span @click='tabchange(3)' :class='{a:cur==3}' @contextmenu.prevent ='right_click' v-if='is_machine_flag'>智能批改结果</span>
                    <span @click='tabchange(4)' :class='{a:cur==4}' @contextmenu.prevent ='right_click' v-if='is_machine_flag'>评分标准</span>
                    <span class="open_content" @click='switch_control'>{{open_close == false? '展开':'收起'}}<i :class="open_close==false?'open_icon':'close_icon'"></i></span>
                </p>
                <div class="single_question" v-if='data'>
                    <!-- 材料 -->
                    <div v-if="cur==0">
                        <div v-for='(i,index) in data.material_content' v-show="open_close">
                          <p class="material_science">材料{{index+1}}</p>
                          <p v-html='i.content'></p>
                          <span class="enclosure" v-for='item in i.appendant'>
                            <span @click='material_enclosure(item)' v-if='item.file_type == 0'><img src="./img/pic.png" alt=""></span>
                            <span @click='material_enclosure(item)' v-else-if='item.file_type == 1'><img src="./img/video.png" alt=""></span>
                            <span @click='material_enclosure(item)' v-else-if='item.file_type == 2'><img src="./img/audio.png" alt=""></span>
                            <span @click='material_enclosure(item)' v-else-if='item.file_type == 3'><img src="./img/attachment.png" alt=""></span>
                          </span>
                        </div>
                        <p class="question_stem" v-html='data.stem'></p>
                        <span class="enclosure" v-for='i in data.stem_appendant'>
                          <span @click='material_enclosure(i)' v-if='i.file_type == 0'><img src="./img/pic.png" alt=""></span>
                          <span @click='material_enclosure(i)' v-else-if='i.file_type == 1'><img src="./img/video.png" alt=""></span>
                          <span @click='material_enclosure(i)' v-else-if='i.file_type == 2'><img src="./img/audio.png" alt=""></span>
                          <span @click='material_enclosure(i)' v-else-if='i.file_type == 3'><img src="./img/attachment.png" alt=""></span>
                        </span>
                        <p v-if='data.stem && (data.form==1 || data.form==5)' class="question_item">选项</p>
                        <p class="item_choice" v-for='(i,index) in data.question_choices' v-if='(data.form==1 || data.form==5)'>
                          <span class="ques_words" :class='i.is_correct == 1?"right_choose":""'>{{String.fromCharCode(index+65)}}</span><span v-html='i.choice'></span>
                        </p>
                        <!-- 按照客观题方式显示 -->
                        <!-- <p v-if='getStudentsAnswer.show_way == 0 && getStudentsAnswer.form==5'>
                          学员作答：<span v-for='(i,index) in data.question_choices'>
                            <span v-for='(j,idx) in (getStudentsAnswer.user_answer.split(","))'>
                              <span v-if='i.id==j'>{{String.fromCharCode(index+65)}}</span>
                            </span>
                          </span>
                          正确答案：<span class="answers" v-for='(i,index) in data.question_choices' v-if='i.is_correct == 1'>{{String.fromCharCode(index+65)}}</span>
                        </p>
                        <p v-if='getStudentsAnswer.show_way == 0 && getStudentsAnswer.user_answer==i.id' v-for='(i,index) in data.question_choices'>
                          学员作答：{{String.fromCharCode(index+65)}}
                          <span class="answers" v-for='(i,index) in data.question_choices' v-if='i.is_correct == 1'>正确答案：{{String.fromCharCode(index+65)}}</span>
                        </p> -->
                        <!-- 按照主观题-文本方式显示 -->
                        <!-- <div v-if='getStudentsAnswer.show_way == 1'>
                          <p class="question_item">学员作答</p>
                          <p v-if='getStudentsAnswer.user_answer'>{{getStudentsAnswer.user_answer}}</p>
                          <p class="cyplayer" v-show='getStudentsAnswer.user_answer_video'>
                            <VideoPlayer :id='getStudentsAnswer.user_answer_video'></VideoPlayer>
                          </p>
                          <p v-if='getStudentsAnswer.user_answer == "" && getStudentsAnswer.user_answer_video == ""'>无</p>
                        </div> -->
                        <!-- 按照画布方式显示 -->
                        <!-- <div class="answerlist" v-if='getStudentsAnswer.show_way == 2'>
                          <p class="question_item">学员作答</p>
                          <div class="canvas_loop" v-if='getStudentsAnswer.user_answer'>
                            <span class="correcting_btn" @click='ismark = true'>画笔批改</span>
                            <div class="swiper-container">
                              <question-swiper
                                :ifShowBtn="false"
                                :questionsListFromProp="JSON.parse(getStudentsAnswer.user_answer)"
                                :qs_id="7"
                                canvasId="canvas1"
                                canvasWrapper="canvas__wrapper1"
                              ></question-swiper>
                            </div>
                          </div>
                        </div> -->
                        <div v-if='getStudentsAnswer.subject'>
                          <p class="question_item">试题考点</p>
                          {{getStudentsAnswer.subject}}
                        </div>
                        <div v-else-if='getStudentsAnswer.subject == ""'>
                          <p class="question_item">试题考点</p>
                          无
                        </div>
                    </div>
                    <!-- 思路点拨 -->
                    <div v-if="cur==1">
                        <div v-if='open_close'>
                          <!-- 无层级 -->
                          <div v-if="data.step_level === 0" class="no-level-wrapper">
                            <p v-html='data.step_explain'></p>
                            <span class="enclosure" v-for='i in data.stepexplain_appendant' :key="i">
                              <span @click='material_enclosure(i)' v-if='i.file_type == 0'><img src="./img/pic.png" alt=""></span>
                              <span @click='material_enclosure(i)' v-else-if='i.file_type == 1'><img src="./img/video.png" alt=""></span>
                              <span @click='material_enclosure(i)' v-else-if='i.file_type == 2'><img src="./img/audio.png" alt=""></span>
                              <span @click='material_enclosure(i)' v-else-if='i.file_type == 3'><img src="./img/attachment.png" alt=""></span>
                            </span>
                          </div>
                          <!-- 有层级 -->
                          <div v-else-if="data.step_level === 1 && data.new_step_explain.length > 0" class="hasLevel-wrapper">
                            <div class="level1-outer" v-for="(item, i) in data.new_step_explain" :key="i">
                              <div class="level1-title"><span class="level-num">{{i + 1}}</span>{{item.title}}</div>
                              <div class="level1-content-wrapper">
                                <p v-html='item.content'></p>
                                <span class="enclosure" v-for='(oneAppend, j) in item.explain_append' :key="j">
                                  <span @click='material_enclosure(oneAppend)' v-if='oneAppend.file_type == 0'><img src="./img/pic.png" alt=""></span>
                                  <span @click='material_enclosure(oneAppend)' v-else-if='oneAppend.file_type == 1'><img src="./img/video.png" alt=""></span>
                                  <span @click='material_enclosure(oneAppend)' v-else-if='oneAppend.file_type == 2'><img src="./img/audio.png" alt=""></span>
                                  <span @click='material_enclosure(oneAppend)' v-else-if='oneAppend.file_type == 3'><img src="./img/attachment.png" alt=""></span>
                                </span>
                              </div>
                              <div class="level2-wrapper" v-if="item.children.length > 0">
                                <div class="level2-outer" v-for="(child, k) in item.children" :key="k">
                                  <div class="level2-title"><span class="level-num">{{i + 1}}.{{k + 1}}</span>{{child.title}}</div>
                                  <div class="level2-content-wrapper">
                                    <p v-html='child.content'></p>
                                    <span class="enclosure" v-for='(childAppend, m) in child.explain_append' :key="m">
                                      <span @click='material_enclosure(childAppend)' v-if='childAppend.file_type == 0'><img src="./img/pic.png" alt=""></span>
                                      <span @click='material_enclosure(childAppend)' v-else-if='childAppend.file_type == 1'><img src="./img/video.png" alt=""></span>
                                      <span @click='material_enclosure(childAppend)' v-else-if='childAppend.file_type == 2'><img src="./img/audio.png" alt=""></span>
                                      <span @click='material_enclosure(childAppend)' v-else-if='childAppend.file_type == 3'><img src="./img/attachment.png" alt=""></span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- 按照客观题方式显示 -->
                        <!-- <p v-if='getStudentsAnswer.show_way == 0 && getStudentsAnswer.form==5'>
                          学员作答：<span v-for='(i,index) in data.question_choices'>
                            <span v-for='(j,idx) in (getStudentsAnswer.user_answer.split(","))'>
                              <span v-if='i.id==j'>{{String.fromCharCode(index+65)}}</span>
                            </span>
                          </span>
                          正确答案：<span class="answers" v-for='(i,index) in data.question_choices' v-if='i.is_correct == 1'>{{String.fromCharCode(index+65)}}</span>
                        </p> -->
                        <!-- <p v-if='getStudentsAnswer.show_way == 0 && getStudentsAnswer.user_answer==i.id' v-for='(i,index) in data.question_choices'>
                          学员作答：{{String.fromCharCode(index+65)}}
                          <span class="answers" v-for='(i,index) in data.question_choices' v-if='i.is_correct == 1'>正确答案：{{String.fromCharCode(index+65)}}</span>
                        </p> -->
                        <!-- 按照主观题-文本方式显示 -->
                        <!-- <div v-if='getStudentsAnswer.show_way == 1'>
                          <p class="question_item">学员作答</p>
                          <p v-if='getStudentsAnswer.user_answer'>{{getStudentsAnswer.user_answer}}</p>
                          <p class="cyplayer" v-show='getStudentsAnswer.user_answer_video'>
                            <VideoPlayer :id='getStudentsAnswer.user_answer_video'></VideoPlayer>
                          </p>
                          <p v-if='getStudentsAnswer.user_answer == "" && getStudentsAnswer.user_answer_video == ""'>无</p>
                        </div> -->
                        <!-- 按照画布方式显示 -->
                        <!-- <div class="answerlist" v-if='getStudentsAnswer.show_way == 2'>
                          <p class="question_item">学员作答</p>
                          <div class="canvas_loop" v-if='getStudentsAnswer.user_answer'>
                            <span class="correcting_btn" @click='ismark = true'>画笔批改</span>
                            <div class="swiper-container">
                              <question-swiper
                                :ifShowBtn="false"
                                :questionsListFromProp="JSON.parse(getStudentsAnswer.user_answer)"
                                :qs_id="7"
                                canvasId="canvas1"
                                canvasWrapper="canvas__wrapper1"
                              ></question-swiper>
                            </div>
                          </div>
                        </div> -->
                    </div>
                    <!-- 解析 -->
                    <div v-if="cur==2">
                        <div v-if='open_close'>
                          <!-- 无层级 -->
                          <div v-if="data.explain_level === 0" class="no-level-wrapper">
                            <p v-html='data.explain_a'></p>
                            <span class="enclosure" v-for='i in data.explain_appendant' :key="i">
                              <span @click='material_enclosure(i)' v-if='i.file_type == 0'><img src="./img/pic.png" alt=""></span>
                              <span @click='material_enclosure(i)' v-else-if='i.file_type == 1'><img src="./img/video.png" alt=""></span>
                              <span @click='material_enclosure(i)' v-else-if='i.file_type == 2'><img src="./img/audio.png" alt=""></span>
                              <span @click='material_enclosure(i)' v-else-if='i.file_type == 3'><img src="./img/attachment.png" alt=""></span>
                            </span>
                          </div>
                          <!-- 有层级 -->
                          <div v-else-if="data.explain_level === 1 && data.new_explain.length > 0" class="hasLevel-wrapper">
                            <div class="level1-outer" v-for="(item, i) in data.new_explain" :key="i">
                              <div class="level1-title"><span class="level-num">{{i + 1}}</span>{{item.title}}</div>
                              <div class="level1-content-wrapper">
                                <p v-html='item.content'></p>
                                <span class="enclosure" v-for='(oneAppend, j) in item.explain_append' :key="j">
                                  <span @click='material_enclosure(oneAppend)' v-if='oneAppend.file_type == 0'><img src="./img/pic.png" alt=""></span>
                                  <span @click='material_enclosure(oneAppend)' v-else-if='oneAppend.file_type == 1'><img src="./img/video.png" alt=""></span>
                                  <span @click='material_enclosure(oneAppend)' v-else-if='oneAppend.file_type == 2'><img src="./img/audio.png" alt=""></span>
                                  <span @click='material_enclosure(oneAppend)' v-else-if='oneAppend.file_type == 3'><img src="./img/attachment.png" alt=""></span>
                                </span>
                              </div>
                              <div class="level2-wrapper" v-if="item.children.length > 0">
                                <div class="level2-outer" v-for="(child, k) in item.children" :key="k">
                                  <div class="level2-title"><span class="level-num">{{i + 1}}.{{k + 1}}</span>{{child.title}}</div>
                                  <div class="level2-content-wrapper">
                                    <p v-html='child.content'></p>
                                    <span class="enclosure" v-for='(childAppend, m) in child.explain_append' :key="m">
                                      <span @click='material_enclosure(childAppend)' v-if='childAppend.file_type == 0'><img src="./img/pic.png" alt=""></span>
                                      <span @click='material_enclosure(childAppend)' v-else-if='childAppend.file_type == 1'><img src="./img/video.png" alt=""></span>
                                      <span @click='material_enclosure(childAppend)' v-else-if='childAppend.file_type == 2'><img src="./img/audio.png" alt=""></span>
                                      <span @click='material_enclosure(childAppend)' v-else-if='childAppend.file_type == 3'><img src="./img/attachment.png" alt=""></span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- 按照客观题方式显示 -->
                        <!-- <p v-if='getStudentsAnswer.show_way == 0 && getStudentsAnswer.form==5'>
                          学员作答：<span v-for='(i,index) in data.question_choices'>
                            <span v-for='(j,idx) in (getStudentsAnswer.user_answer.split(","))'>
                              <span v-if='i.id==j'>{{String.fromCharCode(index+65)}}</span>
                            </span>
                          </span>
                          正确答案：<span class="answers" v-for='(i,index) in data.question_choices' v-if='i.is_correct == 1'>{{String.fromCharCode(index+65)}}</span>
                        </p>
                        <p v-if='getStudentsAnswer.show_way == 0 && getStudentsAnswer.user_answer==i.id' v-for='(i,index) in data.question_choices'>
                          学员作答：{{String.fromCharCode(index+65)}}
                          <span class="answers" v-for='(i,index) in data.question_choices' v-if='i.is_correct == 1'>正确答案：{{String.fromCharCode(index+65)}}</span>
                        </p> -->
                        <!-- 按照主观题-文本方式显示 -->
                        <!-- <div v-if='getStudentsAnswer.show_way == 1'>
                          <p class="question_item">学员作答</p>
                          <p v-if='getStudentsAnswer.user_answer'>{{getStudentsAnswer.user_answer}}</p>
                          <p class="cyplayer" v-show='getStudentsAnswer.user_answer_video'>
                            <VideoPlayer :id='getStudentsAnswer.user_answer_video'></VideoPlayer>
                          </p>
                          <p v-if='getStudentsAnswer.user_answer == "" && getStudentsAnswer.user_answer_video == ""'>无</p>
                        </div> -->
                        <!-- 按照画布方式显示 -->
                        <!-- <div class="answerlist" v-if='getStudentsAnswer.show_way == 2'>
                          <p class="question_item">学员作答</p>
                          <div class="canvas_loop" v-if='getStudentsAnswer.user_answer'>
                            <span class="correcting_btn" @click='ismark = true'>画笔批改</span>
                            <div class="swiper-container">
                              <question-swiper
                                :ifShowBtn="false"
                                :questionsListFromProp="JSON.parse(getStudentsAnswer.user_answer)"
                                :qs_id="7"
                                canvasId="canvas3"
                                canvasWrapper="canvas__wrapper3"
                              ></question-swiper>
                            </div>
                          </div>
                        </div> -->
                    </div>
                    <!-- 智能批改 -->
                    <div v-if="cur==3">
                        <div v-if='open_close'>
                          <p class="question_item">智能批改结果</p>
                          作答分析
                          <div v-if='data.answer_evaluate'>
                            <p class="question_item">总体评价</p>
                            {{data.answer_evaluate}}
                          </div>
                          <p class="question_item">优点</p>
                          <div v-for='i in data.answer_merit'>
                            <p>{{i.part_name}}</p>
                            <p>{{i.list}}</p>
                          </div>
                          <p class="question_item">问题</p>
                          <div v-for='i in data.answer_defect'>
                            <p>{{i.part_name}}</p>
                            <p>{{i.list}}</p>
                          </div>
                          <p class="question_item">建议</p>
                          <div v-html='data.answer_advance'></div>
                          <div class="mar_top">
                            参考答案
                            <p v-html='data.question_correct_answer'></p>
                          </div>
                          <div v-if='data.question_explain'>
                            答案解析
                            <p v-html='data.question_explain'></p>
                          </div>
                        </div>
                        <!-- 按照客观题方式显示 -->
                        <!-- <p v-if='getStudentsAnswer.show_way == 0 && getStudentsAnswer.form==5'>
                          学员作答：<span v-for='(i,index) in data.question_choices'>
                            <span v-for='(j,idx) in (getStudentsAnswer.user_answer.split(","))'>
                              <span v-if='i.id==j'>{{String.fromCharCode(index+65)}}</span>
                            </span>
                          </span>
                          正确答案：<span class="answers" v-for='(i,index) in data.question_choices' v-if='i.is_correct == 1'>{{String.fromCharCode(index+65)}}</span>
                        </p>
                        <p v-if='getStudentsAnswer.show_way == 0 && getStudentsAnswer.user_answer==i.id' v-for='(i,index) in data.question_choices'>
                          学员作答：{{String.fromCharCode(index+65)}}
                          <span class="answers" v-for='(i,index) in data.question_choices' v-if='i.is_correct == 1'>正确答案：{{String.fromCharCode(index+65)}}</span>
                        </p> -->
                        <!-- 按照主观题-文本方式显示 -->
                        <!-- <div v-if='getStudentsAnswer.show_way == 1'>
                          <p class="question_item">学员作答</p>
                          <p v-if='getStudentsAnswer.user_answer'>{{getStudentsAnswer.user_answer}}</p>
                          <p class="cyplayer" v-show='getStudentsAnswer.user_answer_video'>
                            <VideoPlayer :id='getStudentsAnswer.user_answer_video'></VideoPlayer>
                          </p>
                          <p v-if='getStudentsAnswer.user_answer == "" && getStudentsAnswer.user_answer_video == ""'>无</p>
                        </div> -->
                        <!-- 按照画布方式显示 -->
                        <!-- <div class="answerlist" v-if='getStudentsAnswer.show_way == 2'>
                          <p class="question_item">学员作答</p>
                          <div class="canvas_loop" v-if='getStudentsAnswer.user_answer'>
                            <span class="correcting_btn" @click='ismark = true'>画笔批改</span>
                            <div class="swiper-container">
                              <question-swiper
                                :ifShowBtn="false"
                                :questionsListFromProp="JSON.parse(getStudentsAnswer.user_answer)"
                                :qs_id="7"
                                canvasId="canvas1"
                                canvasWrapper="canvas__wrapper1"
                              ></question-swiper>
                            </div>
                          </div>
                        </div> -->
                    </div>
                    <!-- 内容采分点 -->
                    <div v-if="cur==4">
                      <div v-if='open_close'>
                        <p>内容采分点</p>
                        <div v-for='i in data.content_standard'>
                            <p class="content_score"><img src="../../../static/images/papertype.png" alt="">{{i.part_name}}</p>
                            <div v-for='item in i.part_info'>
                                <p>采分点：{{item.score}}分</p>
                                <p>关键句：{{item.keyline}}({{item.score}}分)</p>
                            </div>
                        </div>
                        <p>结构采分点</p>
                        <div v-for='i in data.structure_standard'>
                            <p class="content_score"><img src="../../../static/images/papertype.png" alt="">{{i.part_name}}</p>
                            <div v-for='item in i.part_info'>
                                <p v-if="i.part_info">{{item.remind}}({{item.score}}分)</p>
                            </div>
                        </div>
                      </div>
                      <!-- 按照客观题方式显示 -->
                        <!-- <p v-if='getStudentsAnswer.show_way == 0 && getStudentsAnswer.form==5'>
                          学员作答：<span v-for='(i,index) in data.question_choices'>
                            <span v-for='(j,idx) in (getStudentsAnswer.user_answer.split(","))'>
                              <span v-if='i.id==j'>{{String.fromCharCode(index+65)}}</span>
                            </span>
                          </span>
                          正确答案：<span class="answers" v-for='(i,index) in data.question_choices' v-if='i.is_correct == 1'>{{String.fromCharCode(index+65)}}</span>
                        </p>
                        <p v-if='getStudentsAnswer.show_way == 0 && getStudentsAnswer.user_answer==i.id' v-for='(i,index) in data.question_choices'>
                          学员作答：{{String.fromCharCode(index+65)}}
                          <span class="answers" v-for='(i,index) in data.question_choices' v-if='i.is_correct == 1'>正确答案：{{String.fromCharCode(index+65)}}</span>
                        </p> -->
                        <!-- 按照主观题-文本方式显示 -->
                        <!-- <div v-if='getStudentsAnswer.show_way == 1'>
                          <p class="question_item">学员作答</p>
                          <p v-if='getStudentsAnswer.user_answer'>{{getStudentsAnswer.user_answer}}</p>
                          <p class="cyplayer" v-show='getStudentsAnswer.user_answer_video'>
                            <VideoPlayer :id='getStudentsAnswer.user_answer_video'></VideoPlayer>
                          </p>
                          <p v-if='getStudentsAnswer.user_answer == "" && getStudentsAnswer.user_answer_video == ""'>无</p>
                        </div> -->
                        <!-- 按照画布方式显示 -->
                        <!-- <div class="answerlist" v-if='getStudentsAnswer.show_way == 2'>
                          <p class="question_item">学员作答</p>
                          <div class="canvas_loop" v-if='getStudentsAnswer.user_answer'>
                            <span class="correcting_btn" @click='ismark = true'>画笔批改</span>
                            <div class="swiper-container">
                              <question-swiper
                                :ifShowBtn="false"
                                :questionsListFromProp="JSON.parse(getStudentsAnswer.user_answer)"
                                :qs_id="7"
                                canvasId="canvas1"
                                canvasWrapper="canvas__wrapper1"
                              ></question-swiper>
                            </div>
                          </div>
                        </div> -->
                    </div>
                </div>
                <student-answer style="width: 558px" :getStudentsAnswer="getStudentsAnswer" :data="data" @showMarkPaper="showMarkPaper"></student-answer>
            </div>
            <div class="content_right">
              <div class="content_right__wraper">
                <div class="score__wrapper" v-if="question_form === '4'">
                  <p>教师评分</p>
                  <el-input @blur='check_score' @input='judge_score' v-model="score" placeholder="请输入" :disabled="!can_edit" class="warnbtn"></el-input>
                  <span v-if='is_warn' class="over_score">超过本题总分</span>
                </div>
                <part-comments id="ueditor_comments" ref="ueditor_comments">
                  <p>点评</p>
                </part-comments>
                <questions></questions>
              </div>
            </div>
        </div>
        <el-dialog title="默认语点评" :visible.sync="default_flag">
            <div class="defaultTip">（填写默认语后，作业全部题目都使用当前评语）</div>
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入"
              :readonly="!can_edit"
              v-model="defaultComment">
            </el-input>
            <div class="defaultCommentError" v-if="defaultComment === ''">请填写默认点评</div>
            <span slot="footer" class="dialog-footer" v-show="can_edit">
              <el-button @click="default_flag = false">取 消</el-button>
              <el-button type="primary" @click="saveComments('default')">应用</el-button>
            </span>
        </el-dialog>
        <el-dialog title="整体点评" :visible.sync="ueditor_flag">
            <p style="position: relative;">
              <comments id="ueditor_comments2" ref="ueditor_comments2" :allCommentsDialog="true">
              </comments>
            </p>
            <span slot="footer" class="dialog-footer" v-show="can_edit">
              <el-button @click="ueditor_flag = false">取 消</el-button>
              <el-button type="primary" @click="saveComments">保 存</el-button>
            </span>
        </el-dialog>
        <div class="markpaper" v-if='ismark'>
          <MarkPaper :userAnswer='getStudentsAnswer.user_answer' :ques_id='ques_id' @closeCanvas='closeCanvas'></MarkPaper>
        </div>
    </div>
</template>
<script>
    import VideoPlayer from '@/pages/video-previews/index'
    import Comments from '@/components/ueditor/comments'
    import PartComments from '@/components/ueditor/part-comments'
    import Questions from '@/components/questions/index'
    import global_ from "../../global/index"
    import Swiper from '../../../static/js/swiper-bundle.min.js'
    import MarkPaper from '../mark-paper/index'
    import QuestionSwiper from '@/components/question-swiper/question-swiper'
    import StudentAnswer from './student-answer.vue'
    export default {
        data() {
          return {
            description: window.localStorage.getItem('description'),
            data: null,
            thought_flag: false,
            explain_flag: false,
            is_machine_flag: false,
            cur: 0,
            ueditor_flag: false,
            default_flag: false,
            defaultComment: '',
            open_close: false,
            questionid: '',
            question_form: undefined,
            can_edit: true,
            ismark: false,
            ques_score: '',
            is_warn: false,
            ques_id: this.$route.params.comment_object_id,
            ismock: this.$route.params.object_type == 2?false: true
          }
        },
        components: {
          VideoPlayer,
          Comments,
          PartComments,
          Questions,
          MarkPaper,
          QuestionSwiper,
          StudentAnswer
        },
        computed: {
          comments: {
            get () {
              return this.$store.state.app.comments
            },
            set (value) {
              this.$store.commit('setComments', value)
            }
          },
          upload: {
            get () {
              return this.$store.state.app.upload
            },
            set (value) {
              this.$store.commit('setUpload', value)
            }
          },
          audio: {
            get () {
              return this.$store.state.app.audio
            },
            set (value) {
              this.$store.commit('setAudio', value)
            }
          },
          attachmentFilesList: {
            get () {
              return this.$store.state.app.attachmentFilesList
            },
            set (value) {
              this.$store.commit('setAttachmentFilesList', value)
            }
          },
          score: {
            get () {
              return this.$store.state.app.score
            },
            set (value) {
              this.$store.commit('setScore', value)
            }
          },
          getStudentsAnswer () {
            return this.$store.state.app.students_answer
          },
          getOverall () {
            return this.$store.state.app.overall
          }
        },
        watch:{
          $route(){
            this.getcontent()
            this.getExerciseCorrectRet()
            this.cur=0;
          },
        },
        methods:{
            look_detail(){
                this.$alert(window.localStorage.getItem('description'), '作业要求', {
                    showConfirmButton: false
                });
            },
            tabchange (idx) {
              this.cur = idx
              this.open_close = false
            },
            default_comment(){
              this.default_flag = true
              this.getExerciseCorrectRet()
            },
            judge_score () {
              this.is_warn = false
              this.ques_score = this.$route.params.score
              if ( Number(this.score) > this.ques_score) {
                $('.warnbtn input').addClass('warn')
              } else {
                $('.warnbtn input').removeClass('warn')
              }
            },
            check_score () {
              this.ques_score = this.$route.params.score
              if ( Number(this.score) > this.ques_score) {
                this.is_warn = true
              } else {
                this.is_warn = false
              }
            },
            // 获取默认点评内容
            getExerciseCorrectRet () {
              this.defaultComment = ''
              // const { exercise_id, record_id } = this.$route.params
              const { exercise_id, record_id, comment_type, level_no, comment_object_id, object_type } = this.$route.params
              let params = {
                exercise_id: exercise_id,
                record_id: record_id,
                comment_type: comment_type,
                level_no: level_no,
                comment_object_id: comment_object_id,
                object_type: object_type
              }
              params.correct_from = this.$route.query.correct_from ? this.$route.query.correct_from : 1
              this.$api.GETEXERCISECORRECTRET(params).then(res => {
                if (res.retcode === 0) {
                  let result = res.data
                  this.defaultComment = result.remark
                  this.score = result.correct_score
                }
              })
            },
            getcontent(){
                this.$api.GETEXERCISEQUESTIONINFO({
                    object_id: this.$route.params.object_id,
                    record_id: this.$route.params.record_id,
                    appid: 'pigai',
                    user_id: this.$route.params.sso_id,
                    object_type: this.$route.params.object_type
                }).then((res) => {
                    if (res.retcode === 0) {
                      // this.data = res.data[0]
                      for (let i = 0; i < res.data.length; i++) {
                          if (res.data[i].question_id == this.$route.params.comment_object_id){
                              this.data = res.data[i]
                              this.questionid = res.data[i].questionid
                              this.is_machine_flag = res.data[i].is_machine_correct
                              // 思路点拨
                              if (res.data[i].step_level === 0) {
                                this.thought_flag = res.data[i].step_explain != ''?true: false
                              } else if (res.data[i].step_level === 1) {
                                this.thought_flag = res.data[i].new_step_explain && res.data[i].new_step_explain.length > 0 ? true : false
                              }
                              // 解析
                              if (res.data[i].explain_level === 0) {
                                this.explain_flag = res.data[i].explain_a != ''? true : false
                              } else if (res.data[i].explain_level === 1) {
                                this.explain_flag = res.data[i].new_explain && res.data[i].new_explain.length > 0 != ''? true : false
                              }
                              if (!this.score) {
                                this.score = res.data[i].answer_score
                              }
                              return false
                          } else {
                              this.data = {}
                          }
                      }
                    }
                })
            },
            material_enclosure(item){
              if (item.file_type == 0 || item.file_type == 3) {
                window.open(item.file_url)
              } else if (item.file_type == 1 || item.file_type == 2) {
                let video_window = window.open('')
                let href =  this.$router.resolve({
                  path: '/video-preview/' + item.media_id
                })
                video_window.location = href.href
              }
            },
            right_click(e){
              if (e.currentTarget.innerHTML == '材料'){
                const view = this.$router.resolve({
                  path: `/homework-detail/${this.$route.params.object_id}/${this.$route.params.record_id}/${this.$route.params.object_type}/${this.$route.params.sso_id}/${this.$route.params.comment_object_id}/0`
                })
                window.open(view.href, '_blank')
              } else if(e.currentTarget.innerHTML == '思路点拨'){
                const view = this.$router.resolve({
                  path: `/homework-detail/${this.$route.params.object_id}/${this.$route.params.record_id}/${this.$route.params.object_type}/${this.$route.params.sso_id}/${this.$route.params.comment_object_id}/1`
                })
                window.open(view.href, '_blank')
              } else if(e.currentTarget.innerHTML == '解析'){
                const view = this.$router.resolve({
                  path: `/homework-detail/${this.$route.params.object_id}/${this.$route.params.record_id}/${this.$route.params.object_type}/${this.$route.params.sso_id}/${this.$route.params.comment_object_id}/2`
                })
                window.open(view.href, '_blank')
              } else if(e.currentTarget.innerHTML == '智能批改结果'){
                const view = this.$router.resolve({
                  path: `/homework-detail/${this.$route.params.object_id}/${this.$route.params.record_id}/${this.$route.params.object_type}/${this.$route.params.sso_id}/${this.$route.params.comment_object_id}/3`
                })
                window.open(view.href, '_blank')
              } else if(e.currentTarget.innerHTML == '评分标准'){
                const view = this.$router.resolve({
                  path: `/homework-detail/${this.$route.params.object_id}/${this.$route.params.record_id}/${this.$route.params.object_type}/${this.$route.params.sso_id}/${this.$route.params.comment_object_id}/4`
                })
                window.open(view.href, '_blank')
              }
            },
            saveComments (flag) {
              if (flag === 'default') {
                if (this.defaultComment === '') {
                  return
                }
              }
              const {
                comment_type,
                exercise_id,
                record_id,
                correct_user,
                object_type,
                object_id,
                tiku_user_id,
                sso_id,
                correct_score,
                level_no,
                comment_object_id
              } = this.$route.params
              let params = {
                comment_type: 0,
                exercise_id: exercise_id,
                record_id: record_id,
                correct_user: correct_user,
                object_type: object_type,
                object_id: object_id,
                tiku_user_id: tiku_user_id,
                sso_id: sso_id,
                correct_score: correct_score,
                level_no: 0,
                comment_object_id: ''
              }
              if (flag === 'default') {
                params.comment_text = this.defaultComment
                params.comment_type = 1 // 默认语点评
              } else {
                params.comment_text = this.comments
              }
              let appendant = []
              if (this.upload.media_id) {
                let uploadObj = {
                  file_url: this.upload.url,
                  file_type: this.upload.type,
                  is_lock: 0,
                  media_id: this.upload.media_id,
                  file_name: ''
                }
                // uploadObj = JSON.stringify(uploadObj)
                appendant.push(uploadObj)
              }
              if (this.audio.media_id) {
                let audioObj = {
                  file_url: this.audio.url,
                  file_type: this.audio.type,
                  is_lock: 0,
                  media_id: this.audio.media_id,
                  file_name: ''
                }
                appendant.push(audioObj)
              }
              if (this.attachmentFilesList.length > 0) {
                this.attachmentFilesList.map((item) => {
                  item.pop_flag = 0
                })
                appendant = [...appendant, ...this.attachmentFilesList]
              }
              params.appendant = JSON.stringify(appendant)
              console.log(params)
              params.correct_from = this.$route.query.correct_from ? this.$route.query.correct_from : 1
              this.$api.SAVECOMMENT(params).then(res => {
                if (res.retcode === 0) {
                  this.$message({
                    message: '保存成功',
                    type: 'success',
                    onClose: () => {
                    }
                  });
                  this.ueditor_flag = false
                  this.default_flag = false
                } else {
                  this.$message.error(res.message)
                }
              })
            },
            switch_control() {
              this.open_close = !this.open_close
              var galleryThumbs = new Swiper('.gallery-thumbs', {
                spaceBetween: 10,
                slidesPerView: 4,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true
              });
              var galleryTop = new Swiper('.gallery-top', {
                spaceBetween: 10,
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
                thumbs: {
                  swiper: galleryThumbs
                }
              });
            },
            closeCanvas() {
              this.ismark = false
            },
            showMarkPaper () {
              this.ismark = true
            }
        },
        mounted(){
        },
        created(){
            this.getcontent()
            this.getExerciseCorrectRet()
            this.question_form = this.$route.params.question_form
            console.log(this.$route.params)
            if (this.$route.params.correct_user.indexOf(localStorage.getItem('user_no')) != -1) {
              this.can_edit = true
            } else {
              this.can_edit = false
            }
        }
    }
</script>

<style lang="less" scoped>
.el-dialog__wrapper{
  z-index: 10;
}
.v-modal{
  z-index: 9!important;
}
.warn {
  border: 1px solid red!important;
}
.over_score {
  font-size: 14px;
  color: red;
}
    .first_content{
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #e5e5e5;
        padding-bottom: 10px;
        margin: 0;
        .requirements{
            width: 680px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #7d829a;
            font-size: 14px;
            .require_title{
                font-weight: bold;
            }
        }
        .comment{
            float: right;
            .requirement_detail{
                font-size: 14px;
                margin-right: 15px;
                color: #6594fe;
                cursor: pointer;
            }
        }
        .el-button{
            color: #6594fe;
            border: 1px solid #6594fe;
        }
    }
    .content_box{
        display: flex;
        .content_left{
            flex: 1;
            margin-top: 30px;
            .content_tab{
                span{
                    margin-right: 40px;
                    cursor: pointer;
                    color: #7d829a;
                }
                .a{
                    font-weight: bold;
                    position: relative;
                    color: #2a2e3d;
                }
                .a::before{
                    content: "";
                    position: absolute;
                    left: 10%;
                    top: 24px;
                    width: 80%;
                    height: 4px;
                    border-radius: 2px;
                    background-color: #6594fe;
                }
                .open_content{
                  font-size: 12px;
                  float: right;
                  position: relative;
                  .open_icon{
                    display: inline-block;
                    position: absolute;
                    margin-left: 5px;
                    width: 12px;
                    height: 7px;
                    top: 5px;
                    background: url(../../../static/images/down.png) no-repeat;
                  }
                  .close_icon{
                    display: inline-block;
                    position: absolute;
                    margin-left: 5px;
                    width: 12px;
                    height: 7px;
                    top: 5px;
                    background: url(../../../static/images/down.png) no-repeat;
                    transform: rotate(180deg);
                  }
                }
            }
            .single_question{
                font-size: 14px;
                margin-top: 30px;
                word-break: break-all;
                .question_stem{
                  margin-right: 20px;
                }
                .material_science{
                  font-weight: bold;
                }
                .enclosure{
                  display: inline-block;
                  width: 24px;
                  height: 24px;
                  text-align: center;
                  line-height: 24px;
                  margin-right: 10px;
                  border: 1px solid #e6e7e8;
                  border-radius: 4px;
                  cursor: pointer;
                }
                .question_item{
                    font-weight: bold;
                    position: relative;
                    padding-left: 10px;
                }
                .item_choice{
                  display: flex;
                  align-items: center;
                }
                .question_item::before{
                    content: "";
                    position: absolute;
                    left: 0;
                    top: 3px;
                    height: 14px;
                    width: 4px;
                    border-radius: 2px;
                    background-color: #6594fe;
                }
                .ques_words{
                    margin-right: 10px;
                }
                .right_choose{
                  color: #83d0b4!important;
                }
                .answerlist{
                  padding-right: 30px;
                }
            }
        }
        .content_right{
            width: 370px;
            margin-top: 30px;
            border-left: 1px solid #e5e5e5;
            .content_right__wraper{
              margin-left: 27px;
              width: 342px;
              .score__wrapper{
                width: 40%;
                margin-bottom: 20px;
                p{
                  font-size: 14px;
                  line-height: 14px;
                  color: #2a2e3d;
                  font-weight: bold;
                  background: url("./img/icon.png") no-repeat;
                  padding-left: 14px;
                  margin-top: 0;
                }
              }
            }
        }
        .mar_top {
          margin-top: 20px;
        }
    }
    .el-textarea__inner{
        resize:none;
    }
    .canvas_loop{
      position: relative;
      .correcting_btn{
        position: absolute;
        z-index: 2;
        right: 10px;
        bottom: 65px;
        width: 70px;
        height: 30px;
        color: #6594fe;
        text-align: center;
        line-height: 30px;
        border: 1px solid #6594fe;
        border-radius: 4px;
        background: #ffffff;
        cursor: pointer;
      }
    }
    .markpaper{
      position: fixed!important;
      width: 100%;
      height: 100%;
      z-index: 12;
      top: 0;
      left: 0;
      right: 0;
    }
    .swiper-container {
      width: 546px;
      height: auto;
    }
    .gallery-top .swiper-slide img {
      width: 100%;
      height: 100%;
    }
    .gallery-thumbs {
      width: 100%;
      height: 100px;
      padding: 10px 0;
      background: #eeeeef;
    }
    .gallery-thumbs .swiper-slide {
      width: 20%!important;
      height: 100%;
      margin-right: 5px;
    }
    .gallery-thumbs .swiper-slide img {
      width: 100%;
      height: 100%;
    }
    .content_score{
        img{
            vertical-align: middle;
            margin-right: 10px;
        }
    }
    .cyplayer{
      padding-right: 20px;
      .jw-time-tip{
        white-space: nowrap;
      }
    }
.hasLevel-wrapper{
  border: 1px solid #ebebeb;
  border-radius: 3px;
  margin-right: 25px;
  box-sizing: border-box;
  .level1-outer{
    .level1-title{
      background: #fafafa;
      padding: 10px 15px;
      font-weight: bold;
      .level-num{
        display: inline-block;
        width: 26px;
        text-align: center;
        height: 26px;
        line-height: 26px;
        border-radius: 50%;
        background: #1890ff;
        color: #ffffff;
        margin-right: 5px;
      }
    }
    .level1-content-wrapper, .level2-content-wrapper{
      padding: 0 15px 15px 15px;
    }
    .level2-wrapper{
      .level2-title{
        background: #fafafa;
        padding: 10px 15px;
        font-weight: bold;
        .level-num{
          display: inline-block;
          width: 26px;
          text-align: center;
          height: 26px;
          line-height: 26px;
          border-radius: 50%;
          color: #1890ff;
          margin-right: 5px;
          border: 1px solid #1890ff;
        }
      }
    }
  }
}
.no-level-wrapper{
  margin-right: 25px;
  box-sizing: border-box;
}
.ishide {
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/homework-subject/index.vue